import { setUserType } from 'features/signUp/signUpSlice';
import { SignUpUserType } from 'features/signUp/types';
import { useAppDispatch } from 'store/store';
import { useSignupData } from '../useSignupData';
import { useSignupSectionNavigation } from '../useSignupSectionNaivgation';

export const useUserTypeSelectionStep = () => {
  const appDispatch = useAppDispatch();
  const { isEligibilityCheckRequired: isEligibilityVerificationRequired, isHospitalSsoEnabled } =
    useSignupData();
  const { navigateToNextStep } = useSignupSectionNavigation();

  const submit = (selectedUserType?: SignUpUserType) => {
    const userType = selectedUserType || 'member';
    appDispatch(setUserType(userType));

    if (userType === 'member' && isHospitalSsoEnabled) {
      navigateToNextStep('ShortCutSSO');
      return;
    }

    if (isEligibilityVerificationRequired) {
      navigateToNextStep('ConditionalEligibilityCheck');
      return;
    }

    const nextStep =
      userType === 'caregiver' ? 'CaregiverProfileCreation' : 'MemberProfileCreation';
    navigateToNextStep(nextStep);
  };

  return { submit };
};
